import { useState, useEffect, useRef } from 'react';

export function useLazyMap() {
  const [isVisible, setIsVisible] = useState(false);
  const [isMapInitialized, setIsMapInitialized] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    if (!containerRef.current) return;
    
    const observer = new IntersectionObserver(
      (entries) => {
        // If the element is visible and we haven't initialized the map yet
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          // Once we've detected visibility, disconnect the observer
          observer.disconnect();
        }
      },
      {
        root: null, // Use viewport as root
        rootMargin: '0px',
        threshold: 0.1 // Trigger when at least 10% of the element is visible
      }
    );
    
    observer.observe(containerRef.current);
    
    return () => {
      observer.disconnect();
    };
  }, []);
  
  return {
    containerRef,
    isVisible,
    isMapInitialized,
    setIsMapInitialized
  };
} 